import { forwardRef } from 'react';
import { StyledChrome } from './styled';

const Chrome = forwardRef((props, ref) => (
  <StyledChrome ref={ref} {...props} />
));

export default Chrome;
